import { createWatcher, WatcherType } from 'rewire-core';
import { IRowData, IGrid }            from 'rewire-grid';

export default class SelectedRowsWatcher {
  _watch:           WatcherType<IGrid>;
  lastSelectedRows: IRowData[];

  constructor() {
    this._watch           = createWatcher();
    this.lastSelectedRows = [];
  }

  watch(grid: IGrid, callback: (rows?: any, foundRows?: any) => void) {
    const myCallback = () => {
      const rows = grid.selectedRows;
      if (rows.length === this.lastSelectedRows.length && rows.every(r => this.lastSelectedRows.some(lsr => lsr === r))) return;
      this.lastSelectedRows = rows.slice();

      if (rows.length) {
        const foundRows = grid.rows.filter(gr => rows.some(r => r.id === gr.id));
        callback(foundRows?.map(fr => fr.data) || foundRows, foundRows);
      } else {
        callback(undefined);
      }
    };
    this._watch(grid, ['selectedRows'], myCallback);
  }

  unwatch() {
    this._watch();
  }
}
